<crm-single-select
  [options]="emails"
  [(selectedItem)]="email"
  (selectedItemChange)="emailChange.emit($event)"
  class="w-full {{ isError ? 'ng-invalid ng-dirty' : '' }}"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [showClear]="showClear"
  [filter]="false"
  [appendTo]="appendTo"
  optionLabel="sender">
</crm-single-select>
